import React from 'react';
import styles from './GetStartedTodayTrane.module.css';
import { Row, Col } from 'reactstrap';
import { ReactComponent as EnrollNowIcon } from '../../assets/images/Vendor/Trane/enroll-now-trane.svg';
import { ReactComponent as ComfortSurePortalIcon } from '../../assets/images/Vendor/Trane/comfortsure-portal.svg';
import { ReactComponent as AdminIcon } from '../../assets/images/Vendor/Trane/administration.svg';
import { ReactComponent as CheckMarkIcon } from '../../assets/images/Vendor/Trane/checkmarkSVG.svg';

const GetStartedTodayTrane = () => {
    return (
        <Row className={styles.getStartedContainer}>
            <Col
                className={styles.getStartedDescription}
                md='12'
                lg='6'
            >
                <h1>Get Started Today with ComfortSure</h1>
                <p>
                    The ComfortSure portal makes selling and managing extended service agreements easy! Once enrolled,
                    you can begin customizing plan offerings for each installation.
                </p>
                <ul>
                    <li>
                        <CheckMarkIcon />
                        Competitive labor reimbursement rate options
                    </li>
                    <li>
                        <CheckMarkIcon />
                        Labor only or parts and labor coverage
                    </li>
                    <li>
                        <CheckMarkIcon />
                        Terms available up to 10 years
                    </li>
                </ul>
            </Col>
            <Col
                className={styles.getStartedStepsContainer}
                md='12'
                lg='6'
            >
                <ul className={styles.getStartedSteps}>
                    <li className={styles.getStartedStepBox}>
                        <EnrollNowIcon />
                        <div>
                            <h2>Enroll Now</h2>
                            <p>
                                Complete our <span>online enrollment process</span> and provide a copy of your W-9 and
                                COI documents.
                            </p>
                        </div>
                    </li>
                    <li className={styles.getStartedStepBox}>
                        <ComfortSurePortalIcon />
                        <div>
                            <h2>ComfortSure Portal</h2>
                            <p>
                                Once enrolled, we will setup your ComfortSure account so you can login to our online
                                portal.
                            </p>
                        </div>
                    </li>
                    <li className={styles.getStartedStepBox}>
                        <AdminIcon />
                        <div>
                            <h2>Administration Made Simple</h2>
                            <p>
                                Our user-friendly portal makes it easy for you to enter sales and submit claims for
                                payment.{' '}
                            </p>
                        </div>
                    </li>
                </ul>
            </Col>
        </Row>
    );
};

export default GetStartedTodayTrane;
